import { action as actionCreator } from "typesafe-actions";
import { hasValue } from "@advosys/component-react-utils";
export var AuthenticationActionTypes;
(function (AuthenticationActionTypes) {
    AuthenticationActionTypes["LoginRequest"] = "@@UNIK:domains:authentication:authentication-store:LoginRequest";
    AuthenticationActionTypes["LoginSuccess"] = "@@UNIK:domains:authentication:authentication-store:LoginSuccess";
    AuthenticationActionTypes["LoginFail"] = "@@UNIK:domains:authentication:authentication-store:LoginFail";
    AuthenticationActionTypes["TokenRefreshRequest"] = "@@UNIK:domains:authentication:authentication-store:TokenRefreshRequest";
    AuthenticationActionTypes["TokenRefreshSuccess"] = "@@UNIK:domains:authentication:authentication-store:TokenRefreshSuccess";
    AuthenticationActionTypes["TokenRefreshFail"] = "@@UNIK:domains:authentication:authentication-store:TokenRefreshFail";
    AuthenticationActionTypes["LoadTokenFromStorageRequest"] = "@@UNIK:domains:authentication:authentication-store:LoadTokenFromStorageRequest";
    AuthenticationActionTypes["LoadTokenFromStorageSuccess"] = "@@UNIK:domains:authentication:authentication-store:LoadTokenFromStorageSuccess";
    AuthenticationActionTypes["LoadTokenFromStorageFail"] = "@@UNIK:domains:authentication:authentication-store:LoadTokenFromStorageFail";
    AuthenticationActionTypes["LogoutRequest"] = "@@UNIK:domains:authentication:authentication-store:LogoutRequest";
    AuthenticationActionTypes["LogoutSuccess"] = "@@UNIK:domains:authentication:authentication-store:LogoutSuccess";
    AuthenticationActionTypes["SetTenantId"] = "@@UNIK:domains:authentication:authentication-store:SetTenantId";
    AuthenticationActionTypes["AuthenticateRequest"] = "@@UNIK:domains:authentication:authentication-store:AuthenticateRequest";
    AuthenticationActionTypes["AuthenticateFail"] = "@@UNIK:domains:authentication:authentication-store:AuthenticateFail";
    AuthenticationActionTypes["StartRefreshTokenTimer"] = "@@UNIK:domains:authentication:authentication-store:StartRefreshTokenTimer";
})(AuthenticationActionTypes || (AuthenticationActionTypes = {}));
export const actions = {
    loginRequest: () => actionCreator(AuthenticationActionTypes.LoginRequest),
    loginSuccess: (accessToken, account) => actionCreator(AuthenticationActionTypes.LoginSuccess, { accessToken, account }),
    loginFail: (error) => actionCreator(AuthenticationActionTypes.LoginFail, { error }),
    refreshTokenRequest: () => actionCreator(AuthenticationActionTypes.TokenRefreshRequest),
    refreshTokenSuccess: (accessToken, account) => actionCreator(AuthenticationActionTypes.TokenRefreshSuccess, { accessToken, account }),
    refreshTokenFail: (error) => actionCreator(AuthenticationActionTypes.TokenRefreshFail, { error }),
    loadTokenFromStorageRequest: (accessToken, expiresOn, account) => actionCreator(AuthenticationActionTypes.LoadTokenFromStorageRequest, { accessToken, expiresOn, account }),
    loadTokenFromStorageSuccess: (accessToken, account) => actionCreator(AuthenticationActionTypes.LoadTokenFromStorageSuccess, { accessToken, account }),
    logoutRequest: () => actionCreator(AuthenticationActionTypes.LogoutRequest),
    logoutSuccess: () => actionCreator(AuthenticationActionTypes.LogoutSuccess),
    setTenantId: (tenantId) => actionCreator(AuthenticationActionTypes.SetTenantId, { tenantId }),
    authenticateRequest: () => actionCreator(AuthenticationActionTypes.AuthenticateRequest),
    authenticateFail: (error) => actionCreator(AuthenticationActionTypes.AuthenticateFail, { error }),
    startRefreshTokenTimer: (expiresOn) => actionCreator(AuthenticationActionTypes.StartRefreshTokenTimer, { expiresOn })
};
export var AuthenticationStateOptions;
(function (AuthenticationStateOptions) {
    AuthenticationStateOptions[AuthenticationStateOptions["NotAuthenticated"] = 0] = "NotAuthenticated";
    AuthenticationStateOptions[AuthenticationStateOptions["InProgress"] = 1] = "InProgress";
    AuthenticationStateOptions[AuthenticationStateOptions["Authenticated"] = 2] = "Authenticated";
})(AuthenticationStateOptions || (AuthenticationStateOptions = {}));
const initialState = {
    authenticationState: AuthenticationStateOptions.NotAuthenticated,
    error: undefined,
    accessToken: undefined,
    account: undefined,
    tenantId: undefined
};
export const authenticationReducer = (state = initialState, action) => {
    switch (action.type) {
        case AuthenticationActionTypes.AuthenticateRequest:
        case AuthenticationActionTypes.LoginRequest:
            return { ...state, authenticationState: AuthenticationStateOptions.InProgress, accessToken: undefined, error: undefined };
        case AuthenticationActionTypes.LoginSuccess:
        case AuthenticationActionTypes.TokenRefreshSuccess:
        case AuthenticationActionTypes.LoadTokenFromStorageSuccess:
            return {
                ...state,
                authenticationState: hasValue(action.payload.accessToken) ? AuthenticationStateOptions.Authenticated : AuthenticationStateOptions.NotAuthenticated,
                accessToken: action.payload.accessToken,
                account: action.payload.account,
                error: undefined
            };
        case AuthenticationActionTypes.LoginFail:
        case AuthenticationActionTypes.TokenRefreshFail:
        case AuthenticationActionTypes.AuthenticateFail:
            return { ...state, authenticationState: AuthenticationStateOptions.NotAuthenticated, accessToken: undefined, error: action.payload.error };
        case AuthenticationActionTypes.LogoutRequest:
            return initialState;
        case AuthenticationActionTypes.SetTenantId:
            const tenantId = action.payload.tenantId;
            if (hasValue(tenantId) && state.tenantId !== tenantId)
                return { ...state, tenantId: tenantId };
            return { ...state };
        default:
            return state;
    }
};
